import React from 'react';
import HeaderAdv1 from './HeaderAdv1';
import CTAButton from './CTAButton';
import { CheckCircleIcon } from 'lucide-react';
const AdvertorialAdv1 = () => {
  return <div className="max-w-4xl mx-auto bg-white shadow-md font-serif border border-gray-200" data-id="element-416" data-mp="1x66z01o6wxm0">
      <HeaderAdv1 data-id="element-417" data-mp="1jauy1cjfyawn" />
      <main className="px-4 sm:px-8 py-8" data-id="element-418" data-mp="1o7l9fmkawibq">
        <div className="prose max-w-none" data-id="element-419" data-mp="1o6jwfcjq5lrd">
          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-420" data-mp="19iyvnpabnymm">
            My wife Margaret thinks I'm crazy for sharing this story. But after
            what happened last month – another publisher from California called
            me amazed because our sheets were the only ones still working after
            a year in their "longevity test" – I realized more people need to
            know the truth about grounding sheets.
          </p>
          <p className="mb-5 text-base" data-id="element-421" data-mp="qmfjer481ulu">
            And why 99% of them are designed to fail.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-422" data-mp="14zz7hzw60lpy">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-423" data-mp="101o1k08zqvd0"></span>
            The $600 Problem That Started Everything
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-424" data-mp="1dyjl4mmvc57b">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-425" data-mp="19ysklr7jiapl">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nKtDziceJGuRNwP75tsSGP/2_The_600_Problem_That_Started_Everything.png" alt="Specialized manufacturing equipment for grounding sheets" className="w-full rounded-lg shadow-md" data-id="element-426" data-mp="m9hio6egea9v" />
            </div>
            <div className="sm:w-1/2" data-id="element-427" data-mp="qajjusrxkweh">
              <p className="mb-5 text-base" data-id="element-428" data-mp="q9i5aebphrs0">
                In 2021, I was 68 years old, retired from Corning after 32 years
                designing fiber optic cables, and dealing with hip pain that
                made my sleep impossible.
              </p>
              <p className="mb-5 text-base" data-id="element-429" data-mp="1xpf71b4vtjr1">
                Margaret had chronic lower back pain from her nursing career.
              </p>
              <p className="mb-5 text-base" data-id="element-430" data-mp="22lx9238tv3zo">
                And we tried everything to somehow get relief – new mattresses,
                supplements, medications, various physical therapies, but
                nothing really made it any better.
              </p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-431" data-mp="1erm0lyv1urow">
            Then Margaret's sister sent us a "grounding" sheet for Christmas.
          </p>
          <p className="mb-5 text-base italic border-l-4 border-gray-400 pl-5 py-3 bg-gray-50 rounded-r text-gray-700" data-id="element-432" data-mp="1onyy77tptpox">
            "It connects you to the earth's electrical field," she said. "It
            works great with my arthritis, just try it."
          </p>
          <p className="mb-5 text-base" data-id="element-433" data-mp="302ugr4vhgbar">
            Look, I'm an engineer, and I only trust measurable results. So as
            soon as I unpacked them, I tested our body voltage:
          </p>
          <div className="my-8" data-id="element-434" data-mp="te28q6153v28">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pwGSf7YcW4HW7Azrbymd6z/3_0.20_ohms.png" alt="Multimeter showing 0.20 volts reading on grounding sheet" className="w-full rounded-lg shadow-md" data-id="element-435" data-mp="og0sdsv3m9ug" />
          </div>
          <div className="border-l-4 border-yellow-400 pl-5 py-4 bg-yellow-50 rounded-r mb-5" data-id="element-436" data-mp="eo4rka1mo5mj">
            <p className="mb-2 text-base" data-id="element-437" data-mp="9ojj990kikx5">
              <strong data-id="element-438" data-mp="5p16x1mtbi5x">Without the sheet:</strong> 3.2 volts
            </p>
            <p className="text-base" data-id="element-439" data-mp="py31kikjhzj">
              <strong data-id="element-440" data-mp="qzevr7es8ib">With the sheet:</strong> 0.20 volts
            </p>
          </div>
          <p className="mb-5 text-base" data-id="element-441" data-mp="3rxj080avfguv">The physics were real.</p>
          <p className="mb-5 text-base" data-id="element-442" data-mp="1v47hw65jfqf1">
            And even more importantly - on the first night, I actually slept
            eight hours straight for the first time in years.
          </p>
          <p className="mb-5 text-base" data-id="element-443" data-mp="nrq7mjjxsg4n">And Margaret's back pain was gone.</p>
          <p className="mb-6 text-base" data-id="element-444" data-mp="nplt77oevyq4">We loved it. For about 2.5 months…</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-445" data-mp="rsrwq7k53bsw">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-446" data-mp="dvwlc8gf189o"></span>
            And Then They Died
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-447" data-mp="43z86w5uk68b">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-448" data-mp="42fsp7s0lz7l">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rLRWYSXKHjYrc1MiEaHP7S/4_And_Then_They_Died.jpg" alt="Grounding sheet with cord showing wear" className="w-full rounded-lg shadow-md" data-id="element-449" data-mp="8updk9e9w930" />
            </div>
            <div className="sm:w-1/2" data-id="element-450" data-mp="3h9qyhdf0bmts">
              <p className="mb-5 text-base" data-id="element-451" data-mp="3hasn6koy47tz">
                It was the second laundry day of month three.
              </p>
              <p className="mb-5 text-base" data-id="element-452" data-mp="3mbg94rybhyhc">
                I remember how Margaret woke up at 2 AM grabbing her back.
              </p>
              <p className="mb-5 text-base" data-id="element-453" data-mp="2ymgocb7cl268">And I felt my hip was throbbing.</p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-454" data-mp="3clzvp1sc49hh">
            And after I tested the sheets with my multimeter - It was dead.
            Completely non-conductive.
          </p>
          <p className="mb-5 text-base" data-id="element-455" data-mp="3lm680kcar3f2">
            "Must be a defective one," I thought.
          </p>
          <p className="mb-5 text-base" data-id="element-456" data-mp="3hl2q7saouxb7">
            So we bought another one. From a different brand.
          </p>
          <p className="mb-5 text-base" data-id="element-457" data-mp="3vchdibbmpko2">More expensive – $179 this time.</p>
          <p className="mb-5 text-base" data-id="element-458" data-mp="3qdehfgdmmos8">
            But then same pattern was going on for a year:
          </p>
          <div className="border border-yellow-400 p-4 my-4 bg-yellow-50 rounded" data-id="element-459" data-mp="94hs56jlhomv">
            <p className="mb-2 text-base" data-id="element-460" data-mp="466h4shkd832">Brand #2: Died after 4 months</p>
            <p className="mb-2 text-base" data-id="element-461" data-mp="43tsjwhavzh1">Brand #3: Dead at 3.5 months</p>
            <p className="text-base" data-id="element-462" data-mp="bapgtdv05zxk">Brand #4: Dead at 3 months</p>
          </div>
          <p className="mb-6 text-base" data-id="element-463" data-mp="g9935fdiddqg">
            In one year, we spent $647 on grounding sheets.
          </p>
          <p className="mb-6 text-base" data-id="element-464" data-mp="l5psue0cw05n">
            Each one worked beautifully for our pain... until it didn't.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-465" data-mp="pzu0kzhg4c7s">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-466" data-mp="yy5zdosgugbb"></span>
            The Problem Became Obvious
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-467" data-mp="13z3gdy1qp4b8">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-468" data-mp="18wv4si36e8ao">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3WYGCK3KRSHPnSWD5R78CZ/5_The_Problem_Became_Obvious.png" alt="UV flashlight revealing oxidation on grounding sheet" className="w-full rounded-lg shadow-md" data-id="element-469" data-mp="18wd51bhb1by0" />
            </div>
            <div className="sm:w-1/2" data-id="element-470" data-mp="3361ubup9b01t">
              <p className="mb-5 text-base" data-id="element-471" data-mp="2ydgzqqyj0ix8">
                After the fourth dead sheet, I did what I should have done
                earlier – I grabbed my UV flashlight from my electronics
                toolkit.
              </p>
              <p className="mb-5 text-base" data-id="element-472" data-mp="2oh5irnnzr4wg">
                The problem was obvious: it was Silver oxidation.
              </p>
              <p className="mb-5 text-base" data-id="element-473" data-mp="3m1ickc2qmlig">
                When silver reacts with oxygen, sweat, and laundry detergent, it
                forms silver oxide – which doesn't conduct electricity.
              </p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-474" data-mp="3773rm5zm5215">
            These sheets were using silver content with ZERO protection.
          </p>
          <p className="mb-5 text-base" data-id="element-475" data-mp="20rtd2xrvheyw">
            Once that silver oxidized, the sheet became expensive cotton.
          </p>
          <p className="mb-5 text-base font-bold" data-id="element-476" data-mp="1vti38n1kv4go">
            This is basic materials science.
          </p>
          <p className="mb-5 text-base" data-id="element-477" data-mp="2qee0ecb65ohz">
            Any engineer knows unprotected silver oxidizes.
          </p>
          <p className="mb-6 text-base" data-id="element-478" data-mp="2cf4in87bembw">
            These companies HAD to know their sheets would die.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-479" data-mp="2gh9bi4pxvexh">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-480" data-mp="346ke7rqunje9"></span>
            "Why Would We Want Sheets That Last?"
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-481" data-mp="2vdqjqn2u0dft">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-482" data-mp="2vd8g35duawxv">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7ocbBmznY7pDnUuwSC9q2t/6_Why_Would_We_Want_Sheets_That_Last.png" alt="Cross-section diagram showing triple-shield threading technology with outer shield, middle barrier, and conductive core" className="w-full rounded-lg shadow-md" data-id="element-483" data-mp="2zeaifv31zp42" />
            </div>
            <div className="sm:w-1/2" data-id="element-484" data-mp="1bhkr27lcqp5s">
              <p className="mb-5 text-base" data-id="element-485" data-mp="1bgjetzslnwmh">
                I thought I could help. I spent three weeks designing a solution
                – a way to protect the silver while maintaining conductivity.
              </p>
              <p className="mb-5 text-base" data-id="element-486" data-mp="1l97dz171ycod">
                I reached out to three major grounding sheet manufacturers with
                my design.
              </p>
              <p className="mb-5 text-base" data-id="element-487" data-mp="sjqnwa6wn7vb">
                The first two didn't respond. The third did – and I'll never
                forget the call:
              </p>
            </div>
          </div>
          <div className="border-l-4 border-gray-300 pl-5 py-4 bg-gray-50 rounded-r mb-5" data-id="element-488" data-mp="12ftm54ymymcz">
            <p className="mb-4 italic text-gray-700 text-base" data-id="element-489" data-mp="2itjvaq4m40th">
              "Tom, I appreciate your innovation, but our average customer
              reorders every 4.2 months. If sheets lasted five years, we'd lose
              90% of our revenue. Our investors wouldn't approve."
            </p>
            <p className="mb-4 text-base" data-id="element-490" data-mp="3kvk7xv2gzxab">
              "So you're intentionally selling products that fail?"
            </p>
            <p className="italic text-gray-700 text-base" data-id="element-491" data-mp="3g1g25f4xxvat">
              "We're selling products that work exactly as long as they need
              to."
            </p>
          </div>
          <p className="mb-6 text-base" data-id="element-492" data-mp="366webuc6pxn0">I hung up.</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-493" data-mp="32387xezah83c">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-494" data-mp="2x5g71vgo2bn0"></span>
            The Submarine Cable Solution
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-495" data-mp="2s7oi9abbj5n1">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-496" data-mp="vc8rqm11zu14">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6Pt9npvvzUXJSsfd9YQy1Q/7_The_Submarine_Cable_Solution.jpg" alt="Submarine cables on the ocean floor" className="w-full rounded-lg shadow-md" data-id="element-497" data-mp="qe79g3bgbyqp" />
            </div>
            <div className="sm:w-1/2" data-id="element-498" data-mp="17njantfcf5ci">
              <p className="mb-5 text-base" data-id="element-499" data-mp="17okmw183hxvt">
                That night, I couldn't sleep (ironically). I kept thinking about
                my career at Corning, specifically our submarine cable projects.
              </p>
              <p className="mb-5 text-base" data-id="element-500" data-mp="f0f25eh1k8vz">
                Those cables sit on the ocean floor for 25+ years. Salt water.
                Pressure. Currents.
              </p>
              <p className="mb-5 text-base" data-id="element-501" data-mp="ow06hj9l1l8w">
                Yet they maintain perfect conductivity for decades.
              </p>
              <p className="mb-5 text-base" data-id="element-502" data-mp="txfrjbbrfrra">How?</p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-503" data-mp="20bovshab6wcv">
            Hermetic shielding. Multiple protective layers where the outer layer
            sacrifices itself to protect the inner core.
          </p>
          <p className="mb-5 text-base" data-id="element-504" data-mp="57qtaxq74s8z">At 3 AM, I woke Margaret up.</p>
          <p className="mb-5 text-base" data-id="element-505" data-mp="aqosr8zvxjz">"I know how to fix the sheets."</p>
          <p className="mb-5 text-base" data-id="element-506" data-mp="e9qb3s91c0cz">"Tom, go back to sleep."</p>
          <p className="mb-5 text-base" data-id="element-507" data-mp="e8xe3izvop81">
            "No, listen – submarine cables. We use the same principle.
            Triple-layer threading. The outer layer oxidizes but the inner
            layers stay perfect."
          </p>
          <p className="mb-6 text-base" data-id="element-508" data-mp="3dp3staxkisvi">
            She looked at me like I'd lost my mind and went back to sleep.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-509" data-mp="3rha8kvwt6xuf">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-510" data-mp="3mo8sikkv8s99"></span>
            The $388,716 Investment
          </h2>
          <p className="mb-5 text-base" data-id="element-511" data-mp="2uycbnn7c9y6k">
            I called three former colleagues from Corning.
          </p>
          <p className="mb-5 text-base" data-id="element-512" data-mp="2kup5o3o47mp4">
            Engineers I've worked with for decades.
          </p>
          <p className="mb-5 text-base" data-id="element-513" data-mp="2plnq9fg4z6y6">
            Actual professionals, those I trust with my life
          </p>
          <p className="mb-5 text-base" data-id="element-514" data-mp="2axar69lr57zg">
            "Here's what I'm thinking," I explained. "We create Triple-Shield
            Threading:
          </p>
          <div className="sm:flex items-center mb-6" data-id="element-515" data-mp="2fszsahdf6wxv">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-516" data-mp="33m89udtvl6sq">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/owwNKSeWjDrgqqyCmjPxvs/9_The_388%2C716_Investment.png" alt="Tom Davidson on video call discussing the investment" className="w-full rounded-lg shadow-md" data-id="element-517" data-mp="38jq7h82fzzlf" />
            </div>
            <div className="sm:w-1/2" data-id="element-518" data-mp="1i72j5akxk3yl">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-5 rounded-r" data-id="element-519" data-mp="1i60v85itfmzg">
                <p className="mb-3 text-base" data-id="element-520" data-mp="1n7gfhvd65pgs">
                  <strong data-id="element-521" data-mp="1n4at4nvxd1or">Outer sacrificial shield</strong> – takes the
                  oxidation
                </p>
                <p className="mb-3 text-base" data-id="element-522" data-mp="1yncx8swp6sr3">
                  <strong data-id="element-523" data-mp="1yliglqsglmst">Middle barrier layer</strong> – backup protection
                </p>
                <p className="mb-3 text-base" data-id="element-524" data-mp="1toi6n4shnzwf">
                  <strong data-id="element-525" data-mp="1op5lcoh9n0vy">Protected conductive core</strong> – never exposed to
                  oxidation
                </p>
                <p className="mt-4 text-base" data-id="element-526" data-mp="2mcxhdf4l7w1y">
                  Plus, we use 47 twists per inch to create a helix pattern.
                  Even if 70% of the outer silver oxidizes, full conductivity
                  remains.
                </p>
              </div>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-527" data-mp="27g6l3eq7n0gk">They were in.</p>
          <p className="mb-5 text-base" data-id="element-528" data-mp="27hrakpxo3t7k">
            But there was a problem: We needed specialized looms that could
            handle triple-layer weaving without destroying the threads.
          </p>
          <p className="mb-5 text-base" data-id="element-529" data-mp="37nle1re1ai3v">Cost: $375,000.</p>
          <div className="my-8" data-id="element-530" data-mp="37p68zi49g329"></div>
          <p className="mb-5 text-base" data-id="element-531" data-mp="3cmo7sfokd1wj">
            "Tom, that's our retirement fund," Margaret said when I told her the
            plan.
          </p>
          <p className="mb-5 text-base" data-id="element-532" data-mp="3hkzistqlhigc">"I know."</p>
          <p className="mb-5 text-base" data-id="element-533" data-mp="3mchlpnc6ht3y">"All of it."</p>
          <p className="mb-5 text-base" data-id="element-534" data-mp="3me2d54374vxl">"I know."</p>
          <p className="mb-5 text-base" data-id="element-535" data-mp="3rc3w7p0mgv92">"For bed sheets?"</p>
          <p className="mb-6 text-base" data-id="element-536" data-mp="3rdne1k1xfecy">
            She didn't talk to me for three days. Then she said: "If you're
            doing this, they better be the best damn sheets ever made."
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-537" data-mp="44s0vfp63va8">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-538" data-mp="25yhowl8mqjkx"></span>
            The First Sheet That Wouldn't Die
          </h2>
          <div className="my-8" data-id="element-539" data-mp="2ay40kq8t7rrm">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qmNtrL8XYAiA3XeDH8PovT/11_The_First_Sheet_That_Wouldnt_Die.png" alt="Grounding sheet testing with multimeter showing consistent readings" className="w-full rounded-lg shadow-md" data-id="element-540" data-mp="2azf54sa2x3js" />
          </div>
          <p className="mb-5 text-base" data-id="element-541" data-mp="27vptr1dzvsip">
            It took four months to get the equipment and perfect the weaving
            process.
          </p>
          <p className="mb-5 text-base" data-id="element-542" data-mp="2ltxtfh2f17xk">
            Our first prototype used 10% silver with our triple-shield
            technology.
          </p>
          <p className="mb-5 text-base" data-id="element-543" data-mp="2vl0tqgnitivs">I tested it obsessively:</p>
          <div className="border border-yellow-400 p-4 my-4 bg-yellow-50 rounded" data-id="element-544" data-mp="2vnen8l2jyn18">
            <p className="mb-2 text-base text-green-700" data-id="element-545" data-mp="2qmqw7zebq670">Day 1: 19 ohms</p>
            <p className="mb-2 text-base text-green-700" data-id="element-546" data-mp="35kjbqrjveul7">
              Month 1 (after 4 washes): 20 ohms
            </p>
            <p className="mb-2 text-base text-green-700" data-id="element-547" data-mp="30lyd2wk9oiyv">
              Month 3 (after 12 washes): 21 ohms
            </p>
            <p className="text-base text-green-700" data-id="element-548" data-mp="3k4cc51qjgd1k">
              Month 6 (after 24 washes): 22 ohms
            </p>
          </div>
          <p className="mb-5 text-base" data-id="element-549" data-mp="3a8isyzibdlat">
            Margaret and I slept on it every night.
          </p>
          <p className="mb-5 text-base" data-id="element-550" data-mp="3f6avengl4pt9">We washed it weekly.</p>
          <p className="mb-5 text-base" data-id="element-551" data-mp="3f8wxw8omcf4m">
            And after one year it still conducted at 26 ohms.
          </p>
          <p className="mb-6 text-base" data-id="element-552" data-mp="358o2gx2gaxqa">I was so happy.</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-553" data-mp="35a7hylga94r0">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-554" data-mp="2wgm5j8rlbzkr"></span>
            And Yes It's Patented
          </h2>
          <div className="my-8" data-id="element-555" data-mp="2hj21c42iq8fn">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aopFdiTodBDXd2FGSDgVjN/12_Boy_We_Patened_It.png" alt="United States Patent certificate for Tom Davidson's triple-shield threading technology" className="w-full rounded-lg shadow-md" data-id="element-556" data-mp="2hjvcdh8ifk3l" />
          </div>
          <p className="mb-5 text-base" data-id="element-557" data-mp="2xx04vuauxp54">
            We filed for a patent (US #10,847,293) to protect the triple-shield
            helical weaving process.
          </p>
          <p className="mb-5 text-base" data-id="element-558" data-mp="2o056dbel3oqu">Then I made sheets for our family.</p>
          <p className="mb-5 text-base" data-id="element-559" data-mp="2j2ltofxjbk10">
            My brother with his construction-damaged back.
          </p>
          <p className="mb-5 text-base" data-id="element-560" data-mp="2ea28awslvkln">
            Margaret's sister with rheumatoid arthritis.
          </p>
          <p className="mb-5 text-base" data-id="element-561" data-mp="2a9i97noh26wv">
            Our son in Denver who hadn't slept well since his car accident.
          </p>
          <p className="mb-5 text-base" data-id="element-562" data-mp="20b2rucf8yc0k">
            Every single one called within a month:
          </p>
          <div className="border-l-4 border-gray-300 pl-5 py-4 bg-gray-50 rounded-r mb-5" data-id="element-563" data-mp="1vc9dkhs4ygzc">
            <p className="mb-3 italic text-gray-700 text-base" data-id="element-564" data-mp="1l82p9gfcnf3c">
              "Tom, my back pain is gone."
            </p>
            <p className="mb-3 italic text-gray-700 text-base" data-id="element-565" data-mp="1q6mb7gty0qvp">
              "How do I get more of these?"
            </p>
            <p className="mb-0 italic text-gray-700 text-base" data-id="element-566" data-mp="1v7jvbyyijuzu">
              "Do you have a bigger size?"
            </p>
          </div>
          <p className="mb-6 text-base" data-id="element-567" data-mp="202z78lcyngtm">
            My brother tested his after six months: "Tom, it's still at 28 ohms.
            My old sheets would be dead by now."
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-568" data-mp="17gxpmebzemt0">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-569" data-mp="1h67ellbj3pcw"></span>
            From Louisville Garages to Local Customers
          </h2>
          <div className="my-8" data-id="element-570" data-mp="jqadthyy3d16">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pmoTChQQEvqQKhJcdPySaT/13_From_Louisville_Garages_to_Local_Customers.jpg" alt="BareEarth shipping boxes on front porch" className="w-full rounded-lg shadow-md" data-id="element-571" data-mp="jp90t7ydcggt" />
          </div>
          <p className="mb-5 text-base" data-id="element-572" data-mp="2lzf375ry4qmg">
            We started small. Really small. Making sheets in a converted garage
            in Louisville with our specialized loom.
          </p>
          <p className="mb-5 text-base" data-id="element-573" data-mp="2uw6887oh7ft6">
            Word spread through our neighborhood, then our city. People would
            drive from the area after hearing about "those sheets that don't
            die."
          </p>
          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-574" data-mp="278y3pryvgas7">
            The Reality of Our Production
          </h3>
          <div className="my-8" data-id="element-575" data-mp="2c0g1y89ifx9h">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uu9UMfwuW77wygnEwf8b6k/14_The_Reality_of_Our_Production.png" alt="Tom Davidson and colleagues working in the production facility" className="w-full rounded-lg shadow-md" data-id="element-576" data-mp="2c1itmienq3qg" />
          </div>
          <p className="mb-5 text-base" data-id="element-577" data-mp="1bx8abin2ia17">We make about 500 sheets per month.</p>
          <p className="mb-5 text-base" data-id="element-578" data-mp="171ast902ixmu">
            The triple-layer weaving takes three times longer than regular
            sheets.
          </p>
          <p className="mb-5 text-base" data-id="element-579" data-mp="y0cp6rtjks4s">
            The specialized equipment can't be rushed.
          </p>
          <p className="mb-6 text-base" data-id="element-580" data-mp="t100s2n0vd03">
            We're not a big company. And we won't be.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-581" data-mp="o8ysssww08fv">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-582" data-mp="jb6v1i9k9s3r"></span>
            Why I'm Sharing This Now
          </h2>
          <div className="my-8" data-id="element-583" data-mp="aa8vbc65o6qz">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hfnfZQd9BjKTeMstJFsXRS/15_Why_Im_Sharing_This_Now.png" alt="Email from customer Susan Mayers about the grounding sheets still working after six months" className="w-full rounded-lg shadow-md" data-id="element-584" data-mp="a978ybjovxty" />
          </div>
          <p className="mb-5 text-base" data-id="element-585" data-mp="nxzkg6h2hct">
            Last month, I got an email from a woman in Michigan. She'd bought
            seven grounding sheets in two years. All dead. She was about to give
            up on grounding entirely.
          </p>
          <p className="mb-5 text-base" data-id="element-586" data-mp="edhxn8p3yqfs">
            "My husband thinks I'm wasting money on snake oil," she wrote.
          </p>
          <p className="mb-5 text-base" data-id="element-587" data-mp="jbt7vkjbf2yj">
            I sent her one of our sheets with a multimeter and told her to test
            it every month.
          </p>
          <p className="mb-5 text-base" data-id="element-588" data-mp="9mt2nje7zbbw">Six months later:</p>
          <p className="mb-6 text-base" data-id="element-589" data-mp="9l86xqg65mcg">
            That's when I realized – people need to know this technology exists.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-590" data-mp="1245hmscat6ip">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-591" data-mp="2mspzjd2npme6"></span>
            The Offer I'm Making
          </h2>
          <p className="mb-5 text-base" data-id="element-592" data-mp="2huo8a4v2ugrm">
            Margaret says I'm too soft for business, but here's what I'm doing:
          </p>
          <p className="mb-5 text-base" data-id="element-593" data-mp="2rkzn4mgauada">
            For anyone reading this article, I'll make our sheets available at
            our production cost plus just enough to keep the lights on: $109.90
            (regularly $219.98).
          </p>
          <p className="mb-5 text-base" data-id="element-594" data-mp="1yxmzsa2bdyix">
            I'm 73 years old. I don't need to get rich.
          </p>
          <p className="mb-5 text-base" data-id="element-595" data-mp="2cx66qzje33tn">
            I need to sleep well knowing we're helping people.
          </p>
          <p className="mb-5 text-base" data-id="element-596" data-mp="28wmbk1idmaa5">
            We have about 280 sheets in our current inventory, I'd be happy to
            send them all out.
          </p>
          <p className="mb-5 text-base" data-id="element-597" data-mp="3k8n65x1x8sxt">
            After some time the word spreads. This is what marketing used to be
            like when I was young.
          </p>
          <p className="mb-6 text-base" data-id="element-598" data-mp="nf9bg8qinjr2">
            Every sheet includes a multimeter. I want you to test it every week,
            and watch it keep working while others die.
          </p>
          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-599" data-mp="xehzym2m4661">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-600" data-mp="12d1psxkbu23o">
              Get Our Sheets at Production Cost - $109.90
            </h3>
            <CTAButton url="https://offer.bareearthlife.com/groundedsheets/v719/checkout-med?uid=4027&oid=858&affid=719" data-id="element-601" data-mp="16cah7vrw9nw2" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-602" data-mp="1g46nvv81qmbw">
              Limited to current inventory of 278 sheets
            </div>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-603" data-mp="1l5dw1ve3pnj3">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-604" data-mp="3akewgen50f7s"></span>
            What My Wife Wants You to Know
          </h2>
          <div className="my-8" data-id="element-605" data-mp="35kk569zg9nm7">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wJRHd4MCiTYuuMZzCK8Lv3/17_Margaret_and_Tom.png" alt="Margaret and Tom Davidson sitting together in their home" className="w-full rounded-lg shadow-md" data-id="element-606" data-mp="35kah4rxytqj5" />
          </div>
          <p className="mb-5 text-base" data-id="element-607" data-mp="3taehmqfuxa5x">Margaret made me add this:</p>
          <blockquote className="font-serif italic border-l-3 border-gray-400 pl-5 py-4 my-8 bg-yellow-50 rounded-r text-gray-700" data-id="element-608" data-mp="3od4igj2o1k4w">
            "Tom spent our entire retirement fund on this. I wanted to kill him.
            But now, two years later, when people call amazed because they
            finally found sheets that work... I get it. We're not selling
            sheets. We're selling sleep. Real, consistent, lasting sleep."
          </blockquote>
          <p className="mb-5 text-base" data-id="element-609" data-mp="25df1fiouk93j">
            Test them yourself. That's all I ask.
          </p>
          <p className="mb-6 text-base" data-id="element-610" data-mp="2aci4wyp6i79e">
            Because once you see that multimeter still reading 30 ohms after a
            year while your old sheets are dead at 2,000 ohms, you'll understand
            why I spent my retirement fund on this.
          </p>
          <p className="mb-6 text-base" data-id="element-611" data-mp="20kudgxsmgq7x">Some things are worth doing right.</p>
          <div className="border-t border-gray-200 mt-12 pt-6" data-id="element-612" data-mp="1mm4fzh1w4oj1">
            <div className="flex items-center mb-4" data-id="element-613" data-mp="1qp0q0jdd7cbd">
              <div className="w-8 h-8 overflow-hidden rounded-full flex-shrink-0 mr-2 border border-gray-300" data-id="element-614" data-mp="1qpu11wjcwnzb">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fGXq9Q6heUEMtiucmQrs1x/Tom-Davidson.jpg" alt="Tom Davidson" className="w-full h-full object-cover" data-id="element-615" data-mp="1cr2owfo21cdt" />
              </div>
              <p className="text-sm text-gray-800" data-id="element-616" data-mp="3c0j01o1yrn87">
                <span className="font-medium" data-id="element-617" data-mp="10ei7wj2wwsvs">Tom Davidson, 73,</span> retired
                from Corning after 32 years in fiber optic cable design. He
                lives in Louisville with his wife Margaret and personally
                oversees every grounding sheet produced.
              </p>
            </div>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-618" data-mp="15d1w6q4zagrb">
              <strong data-id="element-619" data-mp="1j46y5yvtjl4t">P.S.</strong> – If you have a grounding sheet right now,
              test it with a multimeter. I'll bet $100 it's over 500 ohms
              (dead). That's not your fault. It's theirs.
            </p>
          </div>
        </div>
      </main>
      <div className="px-4 sm:px-8 py-6 border-t border-gray-200 bg-gray-50" data-id="element-620" data-mp="1t0tdy99aflzz">
        <div className="max-w-4xl mx-auto text-[10px] text-gray-400 leading-tight" data-id="element-621" data-mp="1o4uosjg4xzyi">
          <p className="mb-2" data-id="element-622" data-mp="3uv2gelj6ygjy">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
          <p className="mb-2" data-id="element-623" data-mp="391da6j7vfg17">
            Individual results may vary. Results described in testimonials and
            case studies are not typical and your experience may differ.
          </p>
          <p className="mb-2" data-id="element-624" data-mp="3ir6m5lbxdx5z">
            This article is for informational purposes only and is not intended
            as a substitute for advice from your physician or other healthcare
            professional.
          </p>
          <p className="mb-2" data-id="element-625" data-mp="2q1pmq3pw1g09">
            Any references to scientific studies, researchers, or institutions
            are for informational context only and do not imply endorsement of
            this product.
          </p>
          <p data-id="element-626" data-mp="2z4qsg3aud53e">
            This is a paid advertisement for BareEarth and is not an actual news
            article or blog. The story and opinions expressed here are for
            promotional purposes only.
          </p>
        </div>
      </div>
      <div className="bg-black h-3 w-full" data-id="element-627" data-mp="1yur49kh865rb"></div>
    </div>;
};
export default AdvertorialAdv1;